<template>
  <div class="d-flex flex-column page-break">

    <div class="small-text-font text-center">
      Allocate everything to a Reverse Mortgage Line of Credit
    </div>
    <VueApexCharts v-if="allocateToReverseMortgageLineOfCredit[0].data.length" type="area" width="100%" height="300"
      :options="allocateToReverseMortgageLineOfCreditChartOptions" :series="allocateToReverseMortgageLineOfCredit">
    </VueApexCharts>


    <div class="small-text-font text-center">
      Or <span class="font-weight-bold">receive monthly payments</span> from the Reverse Mortgage
    </div>
    <VueApexCharts v-if="monthlyPaymentsFromTheReverseMortgage[0].data.length" type="bar" width="100%" height="400"
      :options="monthlyPaymentsFromTheReverseMortgageChartOptions" :series="monthlyPaymentsFromTheReverseMortgage">
    </VueApexCharts>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import helpers from '../../helpers';
import colors from '../../assets/colors';

export default {
  components: { VueApexCharts },
  data() {
    return {
      allocateToReverseMortgageLineOfCreditUnchangedChartOptions: {
        chart: {
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false // This disables all zooming, including mouse wheel
          }
        },
        xaxis: {
          type: 'numeric',
          labels: {
            formatter: function (value) {
              return value.toFixed(0);
            },
            style: {
              fontSize: this.$store.state.chartsFonts.small
            }
          }
        },
        yaxis: {
          type: 'numeric',
          labels: {
            formatter: (value) => {
              return this.formatMoney(value);
            },
            style: {
              fontSize: this.$store.state.chartsFonts.small
            }
          }
        },
        tooltip: {
          enabled: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        fill: {
          type: 'solid',
          opacity: 0.8
        },
        colors: [colors.chartYellow]
      },
      monthlyPaymentsFromTheReverseMortgageUnchangedChartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false // This disables all zooming, including mouse wheel
          }
        },
        xaxis: {
          labels: {
            style: {
              fontSize: this.$store.state.chartsFonts.small
            }
          }
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return this.formatMoney(value);
            },
            style: {
              fontSize: this.$store.state.chartsFonts.small
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        tooltip: {
          enabled: false
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'solid',
          opacity: 0.8
        },
        colors: [colors.chartBlue, colors.chartGreen, colors.chartPurple]
      }
    };
  },
  computed: {
    allocateToReverseMortgageLineOfCreditChartOptions() {
      return {
        ...this.$data.allocateToReverseMortgageLineOfCreditUnchangedChartOptions,
        legend: {
          show: true,
          showForSingleSeries: true,
          position: 'bottom',
          horizontalAlign: 'left',
          fontSize: this.$store.state.chartsFonts.medium,
          height: 50,
          offsetX: 40,
          markers: {
            width: 24,
            height: 24,
            radius: 4,
          },
          onItemClick: {
            toggleDataSeries: false
          },
          formatter: (seriesName, opts) => {
            const initialLine = this.roundToThousandsAndFormatMoney(
              opts.w.globals.series[opts.seriesIndex][0]
            );
            return ['-', seriesName, '-', initialLine];
          }
        }
      };
    },
    monthlyPaymentsFromTheReverseMortgageChartOptions() {
      return {
        ...this.$data.monthlyPaymentsFromTheReverseMortgageUnchangedChartOptions,
        legend: {
          height: 100,
          show: true,
          position: 'bottom',
          horizontalAlign: 'left',
          fontSize: this.$store.state.chartsFonts.small,
          offsetX: 80,
          markers: {
            width: 24,
            height: 24,
            radius: 4,
          },
          itemMargin: {
            horizontal: 0,
            vertical: 5
          },
          onItemClick: {
            toggleDataSeries: false
          },
          formatter: (seriesName, opts) => {
            const valueToShow = opts.w.globals.series[opts.seriesIndex].filter(
              (value) => value !== 0
            );
            const stringValue = this.roundToThousandsAndFormatMoney(valueToShow[0]);

            if (seriesName === 'Initial') {
              return `- Compare the initial amount of ${stringValue} to monthly payment examples below`;
            } else if (seriesName === '10 Years') {
              return `- Monthly Payments - 10 Years - ${stringValue} - ${this.formatMoney(
                this.monthly.firstValue
              )} per month`;
            } else if (seriesName === '30 Years') {
              return `- Lifetime (Tenure) payments for the next 30 years - ${stringValue} - ${this.formatMoney(
                this.monthly.secondValue
              )} per month`;
            }
          }
        }
      };
    },
    allocateToReverseMortgageLineOfCredit() {
      const storeData =
        this.$store.state.scenarioData.currentScenarioData.chartsData
          .allocateToReverseMortgageLineOfCredit;
      const data = [];
      for (let object of storeData) {
        data.push({ x: object.age, y: object.mortgageLineOfCredit });
      }
      return [{ name: 'Initial Line of Credit', data }];
    },
    monthlyPaymentsFromTheReverseMortgage() {
      const storeData =
        this.$store.state.scenarioData.currentScenarioData.chartsData
          .montlyPaymentsFromTheReverseMortgage;
      const fields = Object.keys(storeData);
      const series = [];
      for (let currentField of fields) {
        const data = [];
        for (let field of fields) {
          const dataObject = {
            x: storeData[field]?.text,
            y: currentField === field ? storeData[currentField].price : 0
          };
          data.push(dataObject);
        }
        series.push({
          name: storeData[currentField].text,
          data
        });
      }

      console.log({ series })
      return series;
    },
    monthly() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues.monthly;
    }
  },
  methods: {
    formatMoney: helpers.formatMoney,
    roundToThousandsAndFormatMoney: helpers.roundToThousandsAndFormatMoney
  }
};
</script>

<style scoped>
.page-break {
  break-inside: avoid;
  page-break-inside: avoid;
}

@media print {
  .page-break {
    break-before: always;
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>
